import { AxiosInstance } from 'axios'

export function getPhotoList(axios: AxiosInstance, params: Object) {
  return axios({
    url: '/v1/yasldpr',
    method: 'get',
    params: params,
  })
}

export interface UpdatePhotoRequest {
  id: string
  approved: boolean
  description: string
  name: string
}
export function updatePhoto(axios: AxiosInstance, data: UpdatePhotoRequest) {
  return axios({
    url: `/v1/yasldpr/${data.id}`,
    method: 'patch',
    data: data,
  })
}

export function deletePhoto(axios: AxiosInstance, id: string) {
  return axios({
    url: `/v1/yasldpr/${id}`,
    method: 'delete',
  })
}
